import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  /**
   * Open a new tab and display file.
   * @param file Blob - Blob of file.
   * @param mimeType string - Mime Type of file.
   */
  public downloadFile(file: Blob, mimeType: string): void {
    const image = new Blob([file], { type: mimeType });
    const fileURL = window.URL.createObjectURL(image);
    window.open(fileURL, '_blank');
  }

  public downloadFileToiFrame(file: Blob, mimeType: string): string {
    const image = new Blob([file], { type: mimeType });
    const fileURL = window.URL.createObjectURL(image);
    return fileURL;
  }

  /**
   * Handles errors by logging them to the console.
   * NOTE: Retry interceptor shoud handle any UI elements being displayed in error states in most cases.
   *
   * @param error - The error object to be logged.
   * @returns void
   */
  public errorHandling(error: Error): void {
    console.error('Error details:', error);
  }

  /** sanitize Filename */
  public sanitizeFilename(filename: string): string {
    // List of reserved Windows filenames
    const reservedNames = [
      'CON',
      'PRN',
      'AUX',
      'NUL',
      'COM1',
      'COM2',
      'COM3',
      'COM4',
      'COM5',
      'COM6',
      'COM7',
      'COM8',
      'COM9',
      'LPT1',
      'LPT2',
      'LPT3',
      'LPT4',
      'LPT5',
      'LPT6',
      'LPT7',
      'LPT8',
      'LPT9'
    ];

    // Remove the list of special characters from the filename and trim if any.
    let sanitized = filename.replace(/[^a-zA-Z0-9]+/g, '_').replace(/^_+|_+$/g, '');

    // Ensure the filename is not a reserved Windows name (case insensitive)
    const baseName = sanitized.split('.').slice(0, -1).join('.') || sanitized;
    if (reservedNames.includes(baseName.toUpperCase())) {
      sanitized = 'safe_' + sanitized;
    }

    // Trim filename to 255 characters
    if (sanitized.length > 255) {
      const extension = sanitized.includes('.') ? sanitized.split('.').pop() : '';
      const base = sanitized.slice(0, 255 - (extension ? extension.length + 1 : 0));
      sanitized = base + (extension ? '.' + extension : '');
    }

    return sanitized;
  }
}
